import { SURVEY_LIST_SUCCESS, SURVEY_LIST_FILTER_UPDATE, SURVEY_LIST_PAGE_UPDATE, SAVE_SURVEY_SUCCESS, EDIT_SURVEY_SUCCESS, SET_SAVE_SURVEY_STATUS, UPDATE_SURVEY_DATE_SUCCESS, UNMOUNT_ADDEDIT_SURVEY_SUCCESS, GLOBAL_SURVEY_LIST_SUCCESS, SAVE_SURVEY_FAIL, GET_STATUS_QUESTION_SUCCESS } from '../constants/constants';
import { getLocalStorageValue } from '../effects/utils/local-storage';

export function SurveyReducer(state = {
    status: {},
    surveys: [],
    surveyList: [],
    dataCollectorSurveys: [],
    questionStatus: null,
    filter: {
        logic: "and",
        filters: []
    },
    page: {
        skip: 0,
        take: 10
    },
    survey: {}
}, action: any) {
    const loggedInUser = getLocalStorageValue('user');
    switch (action.type) {
        case SURVEY_LIST_SUCCESS:
            if (loggedInUser && loggedInUser.roleId === 3) {
                return {
                    ...state,
                    dataCollectorSurveys: action.payload.data.payload,
                }
            } else {
                return {
                    ...state,
                    surveys: action.payload.data.payload,
                }
            }

        case GLOBAL_SURVEY_LIST_SUCCESS:
            if (loggedInUser && loggedInUser.roleId === 1) {
                return {
                    ...state,
                    surveys: action.payload.data.payload,
                }
            } else {
                return {
                    ...state,
                    surveyList: action.payload.data.payload,
                }
            }
        case SURVEY_LIST_FILTER_UPDATE:
            return {
                ...state,
                filter: action.payload
            }

        case SURVEY_LIST_PAGE_UPDATE:
            return {
                ...state,
                page: action.payload
            }

        case SAVE_SURVEY_SUCCESS:
            return {
                ...state,
                status: action.payload
            }
        case SAVE_SURVEY_FAIL:
            return {
                ...state,
                survey: action.payload
            }

        case UPDATE_SURVEY_DATE_SUCCESS:
            return {
                ...state,
                status: action.payload.data
            }

        case EDIT_SURVEY_SUCCESS:
            return {
                ...state,
                survey: action.payload.data.payload
            }

        case GET_STATUS_QUESTION_SUCCESS:
            return {
                ...state,
                questionStatus: action.payload
            }

        case SET_SAVE_SURVEY_STATUS:
            return {
                ...state,
                status: {}
            }
        case UNMOUNT_ADDEDIT_SURVEY_SUCCESS:
            return {
                ...state,
                survey: action.payload
            }

        default:
            if (loggedInUser && loggedInUser.roleId === 3) {
                return {
                    ...state,
                    surveys: [],
                }
            } else {
                return state;
            }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer.survey.tsx